<template>
    <el-dialog :title="title" :visible.sync="visible" :width="dialogWidth" :before-close="beforeClose"
               :close-on-click-modal=false v-dialogDrag>
        <div class="dialog-content" :class="contentClass" :style="{height:dialogHeight}">
            <div :style="{height:mainHeight}">
                <slot name="main"></slot>
            </div>
            <div v-if="showFooter" class="dialog-btn">
                <slot name="footer"></slot>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "ZmDialog",
        props: {
            dialogType:{
                type:String
            },
            width:{
                type:Number
            },
            height:{
                type:Number
            },
            showFooter:{
                type:Boolean,
                default:true
            },
            title:{
                type:String
            },
            validData:{
                type:Object
            },
            beforeCloseValidChang:{
                type:Boolean,
                default:true
            },
            validStr:{
                type:String
            }
        },
        beforeCreate() {
            this.i18nPage = 'component.ZmDialog.';
        },
        data(){
            return {
                i18nPage : 'component.ZmDialog.',
                visible : false
            }
        },
        computed:{
            contentClass: function () {
                return {
                    'dialog-content-medium': this.dialogType == 'medium',
                    'dialog-content-small': this.dialogType == 'small',
                    'dialog-content-mini': this.dialogType == 'mini'
                }
            },
            dialogHeight: function () {
                return this.dialogType == 'medium' ? '504px' : this.dialogType == 'small' ? '364px' : this.dialogType == 'mini' ? '204px' : this.height + 'px';
            },
            dialogWidth: function () {
                return this.dialogType == 'medium' ? '720px' : this.dialogType == 'small' ? '540px' : this.dialogType == 'mini' ? '330px' : this.width + 'px';
            },
            mainHeight: function () {
                if(this.showFooter){
                    return this.dialogType == 'medium' ? '452px' : this.dialogType == 'small' ? '312px' : this.dialogType == 'mini' ? '152px' : (this.height-52) + 'px';
                }else{
                    return this.dialogType == 'medium' ? '500px' : this.dialogType == 'small' ? '360px' : this.dialogType == 'mini' ? '200px' : (this.height-4) + 'px';
                }
            }
        },
        methods: {
            beforeClose(){
                this.close();
            },
            open(){
                return new Promise((resolve,reject) => {
                    this.visible = true;
                    this.$nextTick(() => {
                        resolve();
                    });
                });
            },
            close(){
                if(this.beforeCloseValidChang){
                    if(JSON.stringify(this.validData) != this.validStr){
                        this.$confirm(this.$t(this.i18nPage+'内容有修改,是否确认关闭？'), this.$t(this.i18nPage+'提示'), {
                            confirmButtonText: this.$t(this.i18nPage+'确定'),
                            cancelButtonText: this.$t(this.i18nPage+'取消'),
                            type: 'warning'
                        }).then(() => {
                            this.visible = false;
                            this.$emit('after-close');
                        });
                    }else{
                        this.visible = false;
                        this.$emit('after-close');
                    }
                }else{
                    this.visible = false;
                    this.$emit('after-close');
                }
            }
        },
        created(){

        }

    };
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// ../../src/components/ZmDialog/index.vue